var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyrightSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 53.5C33.5282 53.5 40.2686 50.708 45.2383 45.7383C50.208 40.7686 53 34.0282 53 27C53 19.9718 50.208 13.2314 45.2383 8.26167C40.2686 3.29196 33.5282 0.5 26.5 0.5C19.4718 0.5 12.7314 3.29196 7.76167 8.26167C2.79196 13.2314 0 19.9718 0 27C0 34.0282 2.79196 40.7686 7.76167 45.7383C12.7314 50.708 19.4718 53.5 26.5 53.5ZM20.641 32.859C23.8707 36.0887 29.1189 36.0887 32.3486 32.859C33.3217 31.8859 34.8951 31.8859 35.8578 32.859C36.8205 33.832 36.8309 35.4055 35.8578 36.3682C30.682 41.5439 22.2973 41.5439 17.1215 36.3682C11.9457 31.1924 11.9457 22.8076 17.1215 17.6318C22.2973 12.4561 30.682 12.4561 35.8578 17.6318C36.8309 18.6049 36.8309 20.1783 35.8578 21.141C34.8848 22.1037 33.3113 22.1141 32.3486 21.141C29.1189 17.9113 23.8707 17.9113 20.641 21.141C17.4113 24.3707 17.4113 29.6189 20.641 32.8486V32.859Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightSolid1);
export default __webpack_public_path__ + "static/media/copyright-solid 1.f1393dea9e77e00d096306107c228b53.svg";
export { ForwardRef as ReactComponent };